import React from "react";
import { Text, Card } from "@jsq/ds/core";
import { type GetPaymentBatchByIdQuery } from "~/graphql/supergraphTypes";
import { toDbId } from "~/utils/graphql-helpers";
import { FieldRow } from "../../utils/FieldRow";
import { formatFieldValue } from "../../utils/formatFieldValue";
import * as styles from "./styles_vanilla.css";

// Types
type PaymentBatchType = NonNullable<GetPaymentBatchByIdQuery["paymentBatch"]>;

interface PaymentBatchCardProps {
  paymentBatch?: PaymentBatchType | null;
}

const PaymentBatchCard: React.FC<PaymentBatchCardProps> = ({ paymentBatch }) => {
  if (!paymentBatch) return null;

  return (
    <Card key="payment-batch" className={styles.resultCard}>
      <Text variant="regular-lg" className={styles.cardTitle}>
        Payment Batch Details
      </Text>
      <div className={styles.cardContent}>
        <FieldRow
          label="ID:"
          value={formatFieldValue(paymentBatch.id)}
          fieldRowClassName={styles.fieldRow}
          fieldLabelClassName={styles.fieldLabel}
          fieldValueClassName={styles.fieldValue}
        />
        <FieldRow
          label="Status:"
          value={formatFieldValue(paymentBatch.status)}
          fieldRowClassName={styles.fieldRow}
          fieldLabelClassName={styles.fieldLabel}
          fieldValueClassName={styles.fieldValue}
        />
        <FieldRow
          label="Created At:"
          value={formatFieldValue(paymentBatch.createdAt)}
          fieldRowClassName={styles.fieldRow}
          fieldLabelClassName={styles.fieldLabel}
          fieldValueClassName={styles.fieldValue}
        />
        <FieldRow
          label="Creator ID:"
          value={formatFieldValue(toDbId(paymentBatch.creatorId))}
          fieldRowClassName={styles.fieldRow}
          fieldLabelClassName={styles.fieldLabel}
          fieldValueClassName={styles.fieldValue}
        />
        <FieldRow
          label="Object ID:"
          value={formatFieldValue(toDbId(paymentBatch.objectId))}
          fieldRowClassName={styles.fieldRow}
          fieldLabelClassName={styles.fieldLabel}
          fieldValueClassName={styles.fieldValue}
        />
        <FieldRow
          label="Net Amount:"
          value={formatFieldValue(paymentBatch.netAmount)}
          fieldRowClassName={styles.fieldRow}
          fieldLabelClassName={styles.fieldLabel}
          fieldValueClassName={styles.fieldValue}
        />
        <FieldRow
          label="Objects Count:"
          value={formatFieldValue(paymentBatch.objectsCount)}
          fieldRowClassName={styles.fieldRow}
          fieldLabelClassName={styles.fieldLabel}
          fieldValueClassName={styles.fieldValue}
        />
        <FieldRow
          label="Payment Description:"
          value={formatFieldValue(paymentBatch.paymentDescription)}
          fieldRowClassName={styles.fieldRow}
          fieldLabelClassName={styles.fieldLabel}
          fieldValueClassName={styles.fieldValue}
        />
        <FieldRow
          label="Required Approval Count:"
          value={formatFieldValue(paymentBatch.requiredApprovalCount)}
          fieldRowClassName={styles.fieldRow}
          fieldLabelClassName={styles.fieldLabel}
          fieldValueClassName={styles.fieldValue}
        />
        <FieldRow
          label="Different Approver Required:"
          value={formatFieldValue(paymentBatch.isDifferentApproverRequired)}
          fieldRowClassName={styles.fieldRow}
          fieldLabelClassName={styles.fieldLabel}
          fieldValueClassName={styles.fieldValue}
        />
        <FieldRow
          label="Canceled At:"
          value={formatFieldValue(paymentBatch.canceledAt)}
          fieldRowClassName={styles.fieldRow}
          fieldLabelClassName={styles.fieldLabel}
          fieldValueClassName={styles.fieldValue}
        />
        <FieldRow
          label="Canceled By User ID:"
          value={
            paymentBatch.canceledByUserId
              ? formatFieldValue(toDbId(paymentBatch.canceledByUserId))
              : "null"
          }
          fieldRowClassName={styles.fieldRow}
          fieldLabelClassName={styles.fieldLabel}
          fieldValueClassName={styles.fieldValue}
        />
      </div>
    </Card>
  );
};

export default PaymentBatchCard;
export { PaymentBatchCard };
export type { PaymentBatchCardProps };
